export default __webpack_public_path__ + "static/media/SlingPlayerCover.2eae6501.png";